import { TMasterBusinessClassification } from "@/api/entities/master-business-classification.entity";
import { setHiddenBusinessClassificationApi } from "@/api/services/global/master";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenBusinessClassificationModalProps = {
  hiddenBusinessClassification?: TMasterBusinessClassification;
  setHiddenBusinessClassification: Dispatch<SetStateAction<TMasterBusinessClassification | undefined>>;
};

export const HiddenBusinessClassificationModal: FC<THiddenBusinessClassificationModalProps> = ({
  hiddenBusinessClassification,
  setHiddenBusinessClassification,
}) => {
  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!hiddenBusinessClassification) return;
    try {
      await setHiddenBusinessClassificationApi(toNumber(hiddenBusinessClassification.id), {
        isHidden: !hiddenBusinessClassification.isHidden,
      });
      toast.success(API_SUCCESS_MESSAGE);
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_BUSINESS_CLASSIFICATION] });
    } catch (error) {
      showError(error);
    } finally {
      setHiddenBusinessClassification(undefined);
    }
  };

  return (
    <Modal
      title={hiddenBusinessClassification?.isHidden ? "有効化の確認" : "無効化の確認"}
      isOpen={!!hiddenBusinessClassification}
      onClose={() => setHiddenBusinessClassification(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenBusinessClassification?.isHidden
          ? `「${hiddenBusinessClassification?.businessCategory}」を有効にしてもよろしいですか？`
          : `「${hiddenBusinessClassification?.businessCategory}」を無効にしてもよろしいですか？`}
      </Typography>
    </Modal>
  );
};
